import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import '../common/MdPage.css';
import * as constantClass from '../fileWithConstants';
import { ChevronLeftIcon } from '../common/mdPageIcons';
import * as anioAcademicoService from '../../services/anioAcademico/anioAcademicoService';
import { classifyAnioAcademicoError, toSaveAnioAcademicoPayload } from '../../services/anioAcademico/anioAcademicoDto';

export class AddAnioAcademico extends Component {
  static displayName = AddAnioAcademico.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      descripcion: '',
      showErrorMessage: false,
      success: false,
      errorMessage: '',
    };
  }

  async componentDidMount() {
    await constantClass.canAccess('WWAnioAcademico');
  }

  handleConfirmButton = () => {
    if (this.state.descripcion.trim().length > 0) {
      this.saveStudent();
      return;
    }
    this.setState({
      showErrorMessage: true,
      errorMessage: 'El campo año es obligatorio',
    });
  };

  handleDescripcionChangeInput = (e) => {
    this.setState({
      descripcion: e.target.value,
      showErrorMessage: false,
      errorMessage: '',
    });
  };

  render() {
    if (this.state.success) {
      return <Redirect to="/md-anios" />;
    }

    const { loading } = this.state;

    return (
      <div className="md-page md-add-anio">
        <Link className="md-page__back-link" to="/md-anios">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 className="md-page__title">Nuevo Año Académico</h1>
        </div>
        <p className="md-page__subtitle">Ingrese el año académico y confirme para guardar el registro.</p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
          {loading ? (
            <div className="md-page__status">Los datos se están guardando, espere unos segundos...</div>
          ) : null}
        </div>

        <div className="md-page__form-card">
          <div className="md-page__field">
            <label className="md-page__field-label" htmlFor="anio-descripcion">
              Año académico
            </label>
            <input
              id="anio-descripcion"
              className="md-page__field-input"
              type="text"
              placeholder="Ingrese año"
              value={this.state.descripcion}
              onChange={this.handleDescripcionChangeInput}
              disabled={loading}
            />
          </div>

          <div className="md-page__form-actions">
            <button
              type="button"
              className="md-page__form-btn md-page__form-btn--primary"
              onClick={this.handleConfirmButton}
              disabled={loading}
            >
              Guardar cambios
            </button>
          </div>
        </div>
      </div>
    );
  }

  async saveStudent() {
    this.setState({ showErrorMessage: false, loading: true });
    try {
      await anioAcademicoService.saveAnioAcademico(
        toSaveAnioAcademicoPayload(this.state.descripcion)
      );
      this.setState({ loading: false, success: true, errorMessage: '' });
    } catch (error) {
      const outcome = classifyAnioAcademicoError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      this.setState({
        loading: false,
        success: false,
        showErrorMessage: true,
        errorMessage: outcome.message,
      });
    }
  }
}
